import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  CmpStatusIconV2,
  CmpStatusIconV3,
  CmpStatusIconV4,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Box, Card, CardContent, Typography } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export const ItemCard = ({ data = [], onClick = () => {}, vMediaQuery }) => {
  return (
    <Grid container spacing={2} marginTop={2}>
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              "& .MuiCardContent-root": {
                padding: "0px !important",
              },
            }}
          >
            <CardContent>
              <Box sx={{ backgroundColor: "#FAF9F6", p: 1.5 }}>
                {/* Name and Position */}
                <Grid container alignItems={'center'}>
                  <Grid item xs={11}>
                    <Typography variant="Subtitle2" fontWeight="bold"   noWrap
                                    sx={{ 
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      display: "block",
                                    }}>
                      {item.ItmName}
                    </Typography>
                    {/* <Typography variant="subtitle2" color="gray">
                   {item.Status}
                  </Typography> */}
                  </Grid>
                  <Grid item xs={1} textAlign={"right"}>
                    {/* <CmpStatusIconV3 xStatus={item?.Indicator} /> */}
                    <CmpStatusIconV4
                      xStatus={item.Indicator}
                      NumberId={item.L_Loc}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box
                display="flex"
                justifyContent={"space-between"}
                paddingX={1.5}
              >
                <Typography
                  variant="h6"
                  color="primary"
                  marginTop={vMediaQuery ? 0.5 : 1}
                >
                  <strong>{item.LocName}</strong>
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: "#F4F4F4",
                  borderRadius: 2,
                  p: "10px",
                  mt: 0.5,
                }}
              >
                <Grid container spacing={1} >
                  <Grid item xs={4} >
                    <Typography variant="caption" color="gray">
                      Qty
                    </Typography>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {item.TotalBaseQty}
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography variant="caption" color="gray">
                      Seg.Qty
                    </Typography>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {item.TotalPickedQty}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="caption" color="gray">
                      Balance
                    </Typography>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {item.BalanceQty}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
